exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar[data-v-4d32b8b2]{height:37px}", ""]);

// exports
